<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

        <div class="mr-6">
          <span
            v-if="connected === true"
            class="flex items-center px-2 py-1 rounded">
            <div class="h-3 w-3 rounded-full mr-2 bg-success"></div> {{ $t('Internet') }} ( {{ $t('Connected') }} )
          </span>

          <span
            v-if="connected === false"
            class="flex items-center px-2 py-1 rounded">
            <div class="h-3 w-3 rounded-full mr-2 bg-danger"></div> {{ $t('Internet') }} ( {{ $t('Not_connected') }} )
          </span>

          <span
            v-if="connected === null"
            class="flex items-center px-2 py-1 rounded">
            <div class="h-3 w-3 rounded-full mr-2 bg-warning"></div> {{ $t('Internet') }} ( {{ $t('Pending') }} )
          </span>
        </div>

        <div class="mr-6">
          <vx-tooltip :text="$t('Upload_data')" color="primary">
            <feather-icon
              @click="startBackup()"
              icon="UploadCloudIcon"
              class="cursor-pointer"
              svgClasses="h-6 w-6"
            />
          </vx-tooltip>
        </div>

        <vs-spacer />

        <i18n class="mr-6" />

        <!-- <search-bar class="mr-2" /> -->

        <!-- <cart-drop-down /> -->

        <!-- <notification-drop-down /> -->

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import Bookmarks            from './components/Bookmarks.vue'
import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-vertical',
  data () {
    return {
      connected: null
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    Bookmarks,
    I18n,
    SearchBar,
    CartDropDown,
    NotificationDropDown,
    ProfileDropDown
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    startBackup () {
      this.$vs.loading()

      this.$http.get(`${this.$store.state.route_for_esm}start/backup`)
        .then((response) => {
          console.log('response: ', response)

          this.connected = response.data.connected

          if (this.connected) {
            window.getESM.success(this.$t('The_data_has_been_successfully_chared'), response)
          } else {
            window.getESM.error(this.$t('Data_loading_failed'))
          }

          this.$vs.loading.close()
        })
        .catch((error) => {
          console.log('error: ', error)
          this.$vs.loading.close()
        })
    },
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    }
  }
}
</script>

